import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import AppBox from "./Box";
import { toSentenceCase } from "../utilities/string-utils";
import AppText from "./Text";
import { SpacingOptions } from "../types/core-types";
import AppLink from "./Link";
export type TabType = "default" | "filled";

export interface BreadCrumbItem {
  label: string;
  href?: string;
}

interface TabProps extends SpacingOptions {
  breadCrumbSeperator?: "/" | "-" | ">" | ">>";
  crumbs: Array<BreadCrumbItem>;
}

export default function AppBreadCrumbs({
  crumbs,
  breadCrumbSeperator = "/",
  p,
  pt,
  pr,
  pb,
  pl,
  px,
  py,
  m,
  mt,
  mr,
  mb,
  ml,
  mx,
  my,
}: TabProps) {
  const classNames = [
    p && `p-${p}`,
    pt && `pt-${pt}`,
    pr && `pr-${pr}`,
    pb && `pb-${pb}`,
    pl && `pl-${pl}`,
    px && `px-${px}`,
    py && `py-${py}`,
    m && `m-${m}`,
    mt && `mt-${mt}`,
    mr && `mr-${mr}`,
    mb && `mb-${mb}`,
    ml && `ml-${ml}`,
    mx && `mx-${mx}`,
    my && `my-${my}`,
    "breadCrumbs",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <AppBox gap="2xs" className={classNames} flexDirection="row">
      {crumbs.map((crumb, index) => (
        <AppBox gap="2xs" key={index}>
          <AppLink
            to={crumb.href ?? ""}
            disabled={index === crumbs.length - 1}
            style={index === crumbs.length - 1 ? {} : {}}
            className="crumb"
          >
            <AppBox gap="3xs">
              <AppText
                fontWeight={index === crumbs.length - 1 ? "semibold" : "normal"}
                className={`${index < crumbs.length - 1 && "is-hover"}`}
                color={index === crumbs.length - 1 ? "default" : "muted"}
              >
                {toSentenceCase(crumb.label)}
              </AppText>
            </AppBox>
          </AppLink>
          {crumbs.length - 1 > index && <AppText color="muted">{breadCrumbSeperator}</AppText>}
        </AppBox>
      ))}
    </AppBox>
  );
}
